export const FETCH_AC_CUSTOMERS_DATA = 'FETCH_AC_CUSTOMERS_DATA'
export const SET_AC_CUSTOMER_LOADER = 'SET_AC_CUSTOMER_LOADER'
export const SET_AC_CUSTOMER_LIST_TABLE_PROPS = 'SET_AC_CUSTOMER_LIST_TABLE_PROPS'
export const SET_AC_CUSTOMER_CHARGER_LIST_TABLE_PROPS = 'SET_AC_CUSTOMER_CHARGER_LIST_TABLE_PROPS'
export const SET_AC_CUSTOMER_UPDATE_HISTORY_LIST_TABLE_PROPS = 'SET_AC_CUSTOMER_UPDATE_HISTORY_LIST_TABLE_PROPS'
export const CLEAR_AC_CUSTOMER_LIST_DATA = 'CLEAR_AC_CUSTOMER_LIST_DATA'
export const FETCH_AC_CUSTOMER_CHARGERS_DATA = 'FETCH_AC_CUSTOMER_CHARGERS_DATA'
export const SET_AC_CUSTOMER_DETAIL_LOADER = 'SET_AC_CUSTOMER_DETAIL_LOADER'
export const FETCH_AC_CUSTOMER_DETAIL_DATA = 'FETCH_AC_CUSTOMER_DETAIL_DATA'
export const CLEAR_AC_CUSTOMER_DETAIL_DATA = 'CLEAR_AC_CUSTOMER_DETAIL_DATA'